import { fetchToken } from '@agissc/ktag-map';
import { useQuery } from '@tanstack/react-query';
import config from '../../../utils/AppConfig';

export interface MapServiceMetadata {
  id?: string;
  layers?: MapServiceLayerMetadata[];
}

export interface MapServiceLayerMetadata {
  downloadLink?: string;
  metadataLink?: string;
  layerId: number;
}

const fetchTopicMetadata = async (mapServiceId: string, isPublic: boolean) => {
  const url = `${config.apis.layers}/${mapServiceId}/metaData`;
  const headers = new Headers();

  if (!isPublic) {
    const token = await fetchToken();
    headers.set('Authorization', `Bearer ${token}`);
  }

  const metadataResponse = await fetch(url, { headers });
  const metadataResult: MapServiceMetadata = await metadataResponse.json();
  return metadataResult;
};

export const useTopicMetadataQuery = (mapServiceId: string, isPublic: boolean) => {
  return useQuery<MapServiceMetadata>({
    queryKey: ['topicLayerMetadata', mapServiceId],
    queryFn: () => fetchTopicMetadata(mapServiceId, isPublic),
    gcTime: 3600000,
    staleTime: Infinity,
  });
};
